import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FirefoxIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M14.7331 6.08211V6.07992C14.7262 6.05617 14.719 6.03242 14.7118 6.00867C14.7103 6.00273 14.7084 5.99679 14.7065 5.99117C14.6931 5.94616 14.6793 5.90116 14.6649 5.85647L14.6631 5.85022C14.5754 5.5778 14.471 5.31104 14.3505 5.05144C14.2338 4.79432 14.0991 4.54577 13.9473 4.30765C13.3612 3.36616 12.5608 2.57653 11.6113 2.00318C10.5215 1.34501 9.27211 0.998057 7.99891 1.00001C7.78012 1.00001 7.56134 1.01063 7.34818 1.03126C6.59431 1.11064 5.32349 1.38159 4.29239 2.28694C8.04579 0.370606 13.0603 2.67821 12.6337 6.96902C12.4818 8.50034 11.1816 9.55257 9.97109 9.73008C9.75579 9.76298 9.53691 9.76518 9.32099 9.73664C6.36459 9.32569 6.54555 6.90277 7.44382 5.86678C6.25613 5.85928 5.33505 7.32904 5.78262 8.77316C4.75277 6.8612 5.79356 3.8667 7.99953 2.96041C5.40694 2.58539 2.97656 3.8417 2.1955 6.02523C2.28878 5.22709 2.47496 4.44257 2.75027 3.68763C2.75027 3.68763 1.33693 4.80455 1.04876 7.1534C1.04438 7.18966 1.04032 7.22591 1.03657 7.26247C1.03501 7.27497 1.03376 7.28747 1.03251 7.30029C1.02146 7.40967 1.01313 7.51977 1.0075 7.63061C1.0075 7.63905 1.0075 7.64749 1.0075 7.65593C1.00531 7.70218 1.00344 7.74968 1.00219 7.79531V7.83437C1.00219 7.88937 1 7.94438 1 7.99969C1 11.8658 4.13455 15 8.00109 15C11.8676 15 15 11.8664 15 8.00032C15.0003 7.35164 14.9105 6.70606 14.7331 6.08211Z"
		></path>
	</svg>
))
